import DefaultEndingPage from '@/app/Survey/DefaultEndingPage.vue';
import Form from '@/app/Survey/Form.vue';
import FormErrorPage from '@/app/Survey/FormErrorPage.vue';
import Survey from '@/app/Survey/Survey.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:apiKey/:formId',
            component: Survey,
            children: [
                { path: '', name: 'page', component: Form },
                { path: 'thanks', name: 'defaultEndingPage', component: DefaultEndingPage },
                { path: 'alreadyAnswered', name: 'alreadyAnswered', component: FormErrorPage },
                { path: 'formExpired', name: 'formExpired', component: FormErrorPage },
                { path: 'formUnavailable', name: 'formUnavailable', component: FormErrorPage },
            ],
        },
    ],
});

export default router;
